import ReportContent from '@app/components/reports/components/report-content';
import { methodology } from './components/methodologies';
import { MethodologyRow } from './components/methodology-row';

export default function Scope3MethodologyAppendix2() {
  return (
    <ReportContent variant="appendix">
      {methodology.slice(4).map((method, idx) => (
        <MethodologyRow key={idx} methodology={method} scope="scope3" />
      ))}
    </ReportContent>
  );
}
